"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ColumnStyleUtil_1 = require("./ColumnStyleUtil");
var ColumnRenderer = function (props) {
    var className = props.className, children = props.children, context = props.context;
    var classHelper = 'scuf-col';
    var isNestedGrid = Array.isArray(children) && children.length > 1;
    if (isNestedGrid) {
        classHelper += ' scuf-grid';
    }
    classHelper = className ? classHelper + ' ' + className : classHelper;
    return (React.createElement("div", { className: classHelper + ColumnStyleUtil_1.genWidthClass(context, props), style: ColumnStyleUtil_1.genOrderStyle(context, props) }, children));
};
ColumnRenderer.displayName = 'ColumnRenderer';
exports.default = ColumnRenderer;
